import { render, staticRenderFns } from "./deliveryinputblock.vue?vue&type=template&id=15b679f6"
import script from "./deliveryinputblock.vue?vue&type=script&lang=ts"
export * from "./deliveryinputblock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports